import { defineComponent as _defineComponent } from 'vue'
import { renderSlot as _renderSlot, normalizeProps as _normalizeProps, guardReactiveProps as _guardReactiveProps, mergeProps as _mergeProps, createCommentVNode as _createCommentVNode, unref as _unref, withCtx as _withCtx, renderList as _renderList, createSlots as _createSlots, openBlock as _openBlock, createBlock as _createBlock } from "vue"

import { Popover } from 'ant-design-vue';
import { popoverProps } from 'ant-design-vue/es/popover/index';
import { nextTick, onMounted, ref } from "vue"

export default /*@__PURE__*/_defineComponent({
  __name: 'main',
  props: {
  ...popoverProps(),
  containerId: {
    type: String,
  }
},
  setup(__props) {

const props = __props;

// const localContainer = ref<HTMLElement | undefined>(document.body);

const getPopupContainer = function () {
  const targetContainer = document.getElementById("render-control-panel")
  if (targetContainer) {
    // console.warn("挂载容器是：render-control-panel")
    return targetContainer
  } else {
    // console.warn("挂载容器是：body")
    return document.body
  }
}

onMounted(() => {
  nextTick(() => {
    getPopupContainer()
  })
})


return (_ctx: any,_cache: any) => {
  return (_openBlock(), _createBlock(_unref(Popover), _mergeProps({ ...props }, { getPopupContainer: getPopupContainer }), _createSlots({
    default: _withCtx(() => [
      _renderSlot(_ctx.$slots, "default")
    ]),
    _: 2
  }, [
    _renderList(_ctx.$slots, (slot, name) => {
      return {
        name: name,
        fn: _withCtx((slotData) => [
          slot
            ? _renderSlot(_ctx.$slots, name, _normalizeProps(_mergeProps({ key: 0 }, slotData)))
            : _createCommentVNode("", true)
        ])
      }
    })
  ]), 1040))
}
}

})